var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtlasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86812 11.0909H7.50008C7.70391 8.57892 8.54464 6.16766 9.93246 4.08166C6.69892 4.92361 4.24364 7.69385 3.86812 11.0909ZM12 4.31891C10.4821 6.27449 9.55344 8.62439 9.32508 11.0909H14.6749C14.4466 8.62439 13.5179 6.27449 12 4.31891ZM14.6749 12.9091C14.4466 15.3756 13.5179 17.7255 12 19.6811C10.4821 17.7255 9.55344 15.3756 9.32508 12.9091H14.6749ZM7.50008 12.9091H3.86812C4.24364 16.3061 6.69892 19.0764 9.93246 19.9183C8.54464 17.8323 7.70391 15.4211 7.50008 12.9091ZM14.0675 19.9183C15.4554 17.8323 16.2961 15.4211 16.4999 12.9091H20.1319C19.7564 16.3061 17.3011 19.0764 14.0675 19.9183ZM20.1319 11.0909H16.4999C16.2961 8.57892 15.4554 6.16766 14.0675 4.08166C17.3011 4.92361 19.7564 7.69385 20.1319 11.0909ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasIcon);
export default __webpack_public_path__ + "static/media/AtlasIcon.0bda1859aa8a089d5324543e80197aa6.svg";
export { ForwardRef as ReactComponent };